import { render, staticRenderFns } from "./TravelAuth.vue?vue&type=template&id=5412fe66&scoped=true&"
import script from "./TravelAuth.vue?vue&type=script&lang=js&"
export * from "./TravelAuth.vue?vue&type=script&lang=js&"
import style0 from "./TravelAuth.vue?vue&type=style&index=0&id=5412fe66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5412fe66",
  null
  
)

export default component.exports